import React, { useEffect, Fragment, useState, useMemo } from "react";
import Moment from "react-moment";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Accordion from "react-bootstrap/Accordion";
import { FaStar } from "react-icons/fa";
import { BiSolidDownArrow } from "react-icons/bi";
import { taskImages } from "../../constants/roles";
import "./clients.css";
import {
  convertTimeToUserTimeZone,
  convertToTimeZone,
  extractTimeFromTimestamp,
  getFullName,
} from "../../utils/CommonFunctions";
import cx from "./clients.module.css";
import { wCategories } from "../../constants/constants";
import { BasicButton } from "./PublishDataTable";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import moment from "moment";
import { useSelector } from "react-redux";

const ratingArr = [
  { star: 1 },
  { star: 2 },
  { star: 3 },
  { star: 4 },
  { star: 5 },
];

const JournalDetailAgency = (props) => {
  let { clientJournal, clientId } = props;

  const { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );

  function completedTasks(journalData) {
    let tasks = journalData?.Task;
    let completed = tasks?.filter(
      (item) => item?.status === "true" && item.shiftId === journalData?.shiftId
    );
    return [completed?.length ?? 0, tasks?.length ?? 0];
  }

  const filteredNotes = useMemo(() => {
    // console.log(clientJournal, "clientJournal-----------");
    const filterByClientAndShift = clientJournal.notesData?.filter(
      (item) =>
        item?.clientId === clientId && item.shiftId === clientJournal.shiftId
    );
    const familyNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "family"
    );
    const cateteamNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "careteammember"
    );
    return { familyNotes, cateteamNotes };
  }, [clientJournal]);

  const filteredTasks = useMemo(() => {
    return clientJournal?.Task.filter(
      (task) =>
        (task?.status === "omitted" || task?.status === "true") &&
        task.shiftId === clientJournal.shiftId
    ).sort((a, b) => {
      if (a.taskType === "wellbeing" && b.taskType !== "wellbeing") return -1;
      if (a.taskType !== "wellbeing" && b.taskType === "wellbeing") return 1;
      return 0;
    });
  }, [clientJournal]);

  const [openPreview, setOpenPreview] = useState("");
  return (
    <>
      <ImagePreviewModal
        openModal={openPreview !== ""}
        handleClose={() => setOpenPreview("")}
        image={openPreview}
      />
      <div className="col-md-6 tabbingMenu journalListScroll">
        {clientJournal?.careTeamId?.length > 0 && (
          <ul className="menuList">
            <li>
              <a>
                <img alt="careteam-profile" src={clientJournal?.clientImage} />
                <div className="body">
                  <p>
                    {clientJournal?.startingTime} - {clientJournal?.endingTime}{" "}
                  </p>
                  <h5>{`${clientJournal?.forClient}`}</h5>

                  <p className="timeBox">
                    <span className="ms-3">
                      <Moment format="Do MMM YYYY">
                        {clientJournal?.Date}
                      </Moment>
                    </span>{" "}
                  </p>
                </div>
              </a>
            </li>
          </ul>
        )}
        <div className="starList">
          {ratingArr.map((item, rIndex) => {
            return (
              <button
                key={rIndex}
                className={rIndex < clientJournal.fndfRating ? "active" : ""}
              >
                <FaStar />
              </button>
            );
          })}
        </div>
        <Tab.Container id="left-tabs-example" defaultActiveKey="taB1">
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="taB1">Tasks</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="taB2">Care Notes</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="taB3">Family Notes</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="taB1">
              <ul className={`TasksList ${cx.tasklist}`}>
                <p style={{ color: "#BB6BD9" }}>
                  {completedTasks(clientJournal)[0]} of{" "}
                  {completedTasks(clientJournal)[1]} Tasks Completed
                </p>
                {filteredTasks?.map((task, tIndex) => {
                  const globalTask = task.globalTask;
                  const taskDoneBy = getFullName(task.doneBy);
                  const conditionsToShowMed =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "no";
                  const conditionsToShowPrn =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "yes";

                  let taskStartTime = "00:00";
                  let taskEndTime = "23:59";
                  if (globalTask?.shiftType?.includes("specific")) {
                    taskStartTime = `${
                      globalTask?.startTime
                      // convertTimeToUserTimeZone(
                      //   globalTask?.startTime,
                      //   clientJournal.shiftTimeZone
                      // ) ?? "--"
                    }`;
                    taskEndTime = `${
                      globalTask?.endTime
                      // convertTimeToUserTimeZone(
                      //   globalTask?.endTime,
                      //   clientJournal.shiftTimeZone
                      // ) ?? "--"
                    }`;
                  } else {
                    taskStartTime = `${
                      clientJournal?.startingTime
                      // convertTimeToUserTimeZone(
                      //   clientJournal?.startingTime,
                      //   clientJournal.shiftTimeZone
                      // ) ?? "--"
                    }`;
                    taskEndTime = clientJournal?.endingTime;
                  }
                  if (conditionsToShowMed) {
                    return (
                      <li key={tIndex}>
                        <div className="listRow justify-content-between">
                          <p>
                            <img alt="dd" src={`/admin/images/s10.svg`} />
                            Medication Reminder
                          </p>
                          <p className={`teamNameInNotes me-5`}>
                            {`${taskStartTime} - ${taskEndTime}`}
                          </p>
                          <img
                            src={
                              task?.status === "true"
                                ? "/admin/images/checkedIco.svg"
                                : "/admin/images/crossIco.svg"
                            }
                            className="boxIcons"
                          />
                        </div>
                        <p>{globalTask?.NM}</p>
                        <p>
                          Dose: {globalTask?.doseAmount}{" "}
                          {globalTask?.UDFS_UOMCD}
                        </p>
                        <p>Dose Route: {globalTask?.adminRoute}</p>
                        <p>
                          Meal Consideration: {globalTask?.mealConsideration}
                        </p>
                        {task?.comments && (
                          <p>Description / Observations: {task?.comments}</p>
                        )}
                        {task?.reason && task?.status === "omitted" && (
                          <p>{`Reason: ${task?.reason}`}</p>
                        )}
                        <p className={`teamNameInNotes`}>
                          {taskDoneBy} (
                          {extractTimeFromTimestamp(
                            task?.timestamp,
                            currentCareSiteData?.timeZone
                          )}
                          )
                        </p>
                      </li>
                    );
                  }
                  if (conditionsToShowPrn) {
                    return (
                      <li key={tIndex}>
                        <div className="listRow justify-content-between">
                          <p>
                            <img alt="rr" src={`/admin/images/s6.svg`} />
                            PRN Med
                          </p>
                          <img
                            src={
                              task?.status === "true"
                                ? "/admin/images/checkedIco.svg"
                                : "/admin/images/crossIco.svg"
                            }
                            className="boxIcons"
                          />
                        </div>
                        <p>{globalTask?.NM}</p>
                        <p>
                          Dose: {globalTask?.doseAmount}{" "}
                          {globalTask?.UDFS_UOMCD}
                        </p>
                        <p>Dose Route: {globalTask?.adminRoute}</p>
                        <p>
                          Meal Consideration: {globalTask?.mealConsideration}
                        </p>
                        {task?.comments && (
                          <p>Description / Observations: {task?.comments}</p>
                        )}{" "}
                        {task?.reason && task?.status === "omitted" && (
                          <p>{`Reason: ${task?.reason}`}</p>
                        )}
                        <p className={`teamNameInNotes`}>
                          {taskDoneBy} (
                          {extractTimeFromTimestamp(
                            task?.timestamp,
                            currentCareSiteData?.timeZone
                          )}
                          )
                        </p>
                      </li>
                    );
                  }
                  const taskImgObj = taskImages.find((elem) =>
                    globalTask?.taskName?.includes(elem?.Ctg)
                  );
                  let mesuredValue = "";
                  if (globalTask?.taskType === "BP") {
                    mesuredValue = task.input
                      ? `: ${task.input?.Systolic_BP?.measureValue}/${task.input?.Diastolic_BP?.measureValue} ${task.input?.Diastolic_BP?.measureType}`
                      : "";
                  } else {
                    mesuredValue =
                      task.input && task.input?.measureValue !== ""
                        ? `: ${task.input?.measureValue} ${task.input?.measureType}`
                        : "";
                  }
                  const isWellbeing =
                    task.taskCategory === "wellbeing" ||
                    task?.taskType === "wellbeing";
                  return (
                    <>
                      {isWellbeing ? (
                        <Fragment key={tIndex}>
                          <li>
                            <div className="listRow">
                              <img src="/admin/images/s9.svg" />
                              Wellbeing Assessment
                              <img
                                src={
                                  task?.status === "omitted"
                                    ? "/admin/images/crossIco.svg"
                                    : "/admin/images/checkedIco.svg"
                                }
                                className="boxIcons"
                              />
                            </div>
                          </li>
                          <Accordion className="colorIcon">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header
                                style={{ borderBottom: "none" }}
                              >
                                <BiSolidDownArrow />
                              </Accordion.Header>
                              <Accordion.Body>
                                <ul>
                                  {wCategories.map((wellCat, wIndex) => {
                                    const ratingCount = [1, 2, 3, 4, 5, 6];
                                    const rating = task?.[wellCat.wCat] ?? 0;
                                    return (
                                      <li key={wIndex}>
                                        <label>{wellCat.displayName}</label>
                                        <div>
                                          {ratingCount.map((count) => (
                                            <button>
                                              <img
                                                className={
                                                  rating === count
                                                    ? "wellbineColor"
                                                    : ""
                                                }
                                                src={`/admin/images/is${count}.svg`}
                                              />
                                            </button>
                                          ))}
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                          {task?.reason && task?.status === "omitted" && (
                            <p className="mt-1">{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {taskDoneBy} (
                            {extractTimeFromTimestamp(
                              task?.timestamp,
                              currentCareSiteData?.timeZone
                            )}
                            )
                          </p>
                        </Fragment>
                      ) : (
                        <li key={tIndex}>
                          <div className="listRow justify-content-between">
                            <p>
                              <img alt="icon" src={taskImgObj?.image || ""} />
                              {task?.taskName}
                            </p>

                            <p className={`teamNameInNotes me-5`}>
                              {`${taskStartTime} - ${taskEndTime}`}
                            </p>
                            <img
                              src={
                                task?.status === "omitted"
                                  ? "/admin/images/crossIco.svg"
                                  : "/admin/images/checkedIco.svg"
                              }
                              className="boxIcons"
                            />
                          </div>
                          <p>
                            {globalTask?.taskType}: {mesuredValue || "-"}
                          </p>
                          <p>
                            Description / Observations: {task?.comments || "-"}
                          </p>
                          {task?.reason && task?.status === "omitted" && (
                            <p>{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {taskDoneBy} (
                            {extractTimeFromTimestamp(
                              task?.timestamp,
                              currentCareSiteData?.timeZone
                            )}
                            )
                          </p>
                        </li>
                      )}
                    </>
                  );
                })}
              </ul>
            </Tab.Pane>
            <Tab.Pane eventKey="taB2">
              {filteredNotes?.cateteamNotes?.map((elem) => (
                <div className="rightTextTabs" key={elem._id}>
                  {elem.media && (
                    <BasicButton onClick={() => setOpenPreview(elem.media)}>
                      <img src={elem.media} />
                    </BasicButton>
                  )}
                  <p>{elem.notesData}</p>
                  <p>
                    {getFullName(elem?.careTeamId)} (
                    {extractTimeFromTimestamp(
                      elem.createdAt,
                      currentCareSiteData?.timeZone
                    )}
                    )
                  </p>
                </div>
              ))}
              {filteredNotes?.cateteamNotes?.length < 1 && (
                <p>No data available</p>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="taB3">
              {filteredNotes?.familyNotes?.map((elem) => (
                <div className="rightTextTabs" key={elem._id}>
                  {elem.media && (
                    <BasicButton onClick={() => setOpenPreview(elem.media)}>
                      <img src={elem.media} />
                    </BasicButton>
                  )}
                  <p>{elem.notesData}</p>
                  <p>
                    {getFullName(elem?.careTeamId)} (
                    {extractTimeFromTimestamp(
                      elem.createdAt,
                      currentCareSiteData?.timeZone
                    )}
                    )
                  </p>
                </div>
              ))}
              {filteredNotes?.familyNotes?.length < 1 && (
                <p>No data available</p>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default JournalDetailAgency;
